import ReportBlock from './ReportBlock';

export default ReportBlock;
